import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReactiveService {

  private requestCompleted = new BehaviorSubject<boolean>(false);
  private languageObject = new BehaviorSubject<any>(null);

  isCompleted$ = this.requestCompleted.asObservable();
  languageOffline$ = this.languageObject.asObservable();

  constructor() { }

  updateRequestCompletedValue(param: boolean) {
    this.requestCompleted.next(param);
  }

  setReactiveText(object: any) {
    this.languageObject.next(object);
  }

}
